import { useThunkDispatch } from "setup/redux/thunkDispatch";
import {
  PaymentProviderComponentProps,
  disablePaymentProvider,
  enablePaymentProvider,
  getBlinkSettings,
  selectBlinkSettings,
  updateBlinkSettings,
} from "../components/PaymentProvidersSlice";
import { PaymentProviders } from "global/enums";
import PaymentProvider, { PaymentProviderSettingsProps } from "../components/PaymentProvider";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { BlinkSettingsModel } from "services/api/cplapi/CPLAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons";

const validationSchema = Yup.object().shape({
  paymentDescription: Yup.string().required("Payment description is required"),
});

const BlinkSettings: React.FC<PaymentProviderSettingsProps> = ({ allowEditing }: PaymentProviderSettingsProps) => {
  const thunkDispatch = useThunkDispatch();
  const blinkSettings = useSelector(selectBlinkSettings);

  useEffect(() => {
    thunkDispatch(getBlinkSettings());
  }, [thunkDispatch]);

  const handleSubmit = (values: BlinkSettingsModel) => {
    thunkDispatch(updateBlinkSettings(values));
  };
  return (
    <Formik
      initialValues={blinkSettings}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        if (allowEditing) handleSubmit(values);
      }}
      enableReinitialize
    >
      <Form>
        <div className="row mb-6">
          <label className="form-label">Payment Description</label>
          <Field
            data-test-id="blink-settings-form__payment-description-input"
            className="form-control form-control-solid"
            name="paymentDescription"
            disabled={!allowEditing}
          />
        </div>
        {allowEditing && (
          <div className="row mb-6">
            <button data-test-id="blink-settings-form__save-button" className="btn btn-success" type="submit">
              Save
            </button>
          </div>
        )}
      </Form>
    </Formik>
  );
};

const Blink: React.FC<PaymentProviderComponentProps> = ({ displayName }: PaymentProviderComponentProps) => {
  const thunkDispatch = useThunkDispatch();

  const setPaymentProviderEnabled = (enable: boolean) => {
    if (enable) {
      thunkDispatch(enablePaymentProvider(PaymentProviders.Blink));
    } else {
      thunkDispatch(disablePaymentProvider());
    }
  };

  const blinkSettings = useSelector(selectBlinkSettings);

  useEffect(() => {
    thunkDispatch(getBlinkSettings());
  }, [thunkDispatch]);

  return (
    <PaymentProvider
      paymentProviderDisplayName={displayName}
      paymentProviderID={PaymentProviders.Blink}
      setPaymentProviderEnabled={setPaymentProviderEnabled}
      PaymentProviderSettings={BlinkSettings}
      PaymentProviderSetup={() => (
        <>
          <div className="row mb-6">
            <div className="col-lg-12">
              <h4>Blink Setup</h4>
              <p>Connect your Blink account to collect bank payments on the CPL Client Portal</p>
            </div>
          </div>
          <div className="row mb-6">
            <label className="col-lg-4 form-label">API key supplied</label>
            <div className="col-lg-8">
              {blinkSettings.apiKeySupplied ? (
                <FontAwesomeIcon className="text-success" size="lg" icon={faCheck} />
              ) : (
                <FontAwesomeIcon className="text-danger" size="lg" icon={faTimes} />
              )}
            </div>
          </div>
          <div className="row mb-6">
            <label className="col-lg-4 form-label">Secret key supplied</label>
            <div className="col-lg-8">
              {blinkSettings.secretKeySupplied ? (
                <FontAwesomeIcon className="text-success" size="lg" icon={faCheck} />
              ) : (
                <FontAwesomeIcon className="text-danger" size="lg" icon={faTimes} />
              )}
            </div>
          </div>
          <div className="row mb-6">
            <label className="col-lg-4 form-label">Setup complete</label>
            <div className="col-lg-8">
              {blinkSettings.setupComplete ? (
                <FontAwesomeIcon className="text-success" size="lg" icon={faCheck} />
              ) : (
                <FontAwesomeIcon className="text-danger" size="lg" icon={faTimes} />
              )}
            </div>
          </div>
        </>
      )}
    />
  );
};

export default Blink;
